/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Free_MessagesInputs */



/**
* | output |
* | --- |
* | "Daily AI usage allowance" |
*
* @param {Plan_Feature_Free_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_messages = /** @type {((inputs?: Plan_Feature_Free_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tägliches KI-Nutzungsguthaben")
	return /** @type {LocalizedString} */ ("Daily AI usage allowance")
});